/**
 * Service: config
 *
 * Sets configurations for only predefined types
 * app, services, directives, factories, and views
 *
 * New configurations types can not be added they can only read
 * You may set any key => value pairs within those types
 *
 * Configurations should be initialized in the AppController
 * Configurations should be set in the LoginController
 * Configurations should be cleared after every logout
 */
angular.module('acme.common.service.config', [
  'acme.common.service.api',
  'angularUUID2'
])
.constant('UserPreferenceConfigIds', {
  views: {
    'application.orders.list' : {
      grid: {
        'application.orders.list.grid0': 'efe7c293-5e80-4879-8310-bad55875aa59'
      }
    }
  }
})
.service('ConfigService', ['$rootScope', 'ApiService', 'UserPreferenceConfigIds', 'uuid2', function($rootScope, ApiService, UserPreferenceConfigIds, uuid2) {

    return {

      settings: {
        app: {},
        services: {},
        directives: {},
        factories: {},
        views: {}
      },

      settingsTypes: {
        app: 'apps',
        service: 'services',
        directive: 'directives',
        view: 'views'
      },

      /**
       * Initialize settings
       *
       * Accepts: Array of Objects
       *
       * {
       *   type: {String} // app|services|directives|factories|views
       *   name: {String}
       *   value: {*}
       * }
       *
       * @param (optional) settings {Object}
       */
      init: function(settings) {

        var i, ii,
            r = true;

        if (settings) {
          if (settings instanceof Array) {
            for (i = 0, ii = settings.length; i < ii; i++) {
              if (!this.set(settings[i])) {
                r = false;
                break;
              }
            }
          } else {
            r = this.set(settings);
          }
        }

        return r;

      },

      getConfigId: function(type, name, configType, configName) {
        var r = uuid2.newuuid();
        if (type && name && configType && configName) {
          if (UserPreferenceConfigIds.hasOwnProperty(type)) {
            if (UserPreferenceConfigIds[type].hasOwnProperty(name)) {
              if (UserPreferenceConfigIds[type][name].hasOwnProperty(configType)) {
                if (UserPreferenceConfigIds[type][name][configType].hasOwnProperty(configName)) {
                  r = UserPreferenceConfigIds[type][name][configType][configName];
                }
              }
            }
          }
        }
        return r;

      },

      setConfigId: function(type, name, config) {
        var r = false;
        if (type && name && config.type && config.name) {
          if (!UserPreferenceConfigIds.hasOwnProperty(type)) {
            UserPreferenceConfigIds[type] = {};
            UserPreferenceConfigIds[type][name] = {};
            UserPreferenceConfigIds[type][name][config.type] = {};
            UserPreferenceConfigIds[type][name][config.type][config.name] = config.id;

          } else {
            if (!UserPreferenceConfigIds[type].hasOwnProperty(name)) {
              UserPreferenceConfigIds[type][name] = {};
              UserPreferenceConfigIds[type][name][config.type] = {};
              UserPreferenceConfigIds[type][name][config.type][config.name] = config.id;
            } else {
              if (!UserPreferenceConfigIds[type][name].hasOwnProperty(config.type)) {
                UserPreferenceConfigIds[type][name][config.type] = {};
                UserPreferenceConfigIds[type][name][config.type][config.name] = config.id;
              } else {
                UserPreferenceConfigIds[type][name][config.type][config.name] = config.id;
              }
            }
          }
        }
      },

      /**
       * Get a predefined type value
       *
       * @param type {String}
       * @param name {String}
       * @returns {boolean}
       */
      get: function(type, name) {

        var r = false;

        if (type && name) {
          if (this.settings.hasOwnProperty(type)) {
            if (this.settings[type].hasOwnProperty(name)) {
              r = this.settings[type][name];
            }
          }
        }

        return r;
      },

      /**
       * Get user preferences of a predefined type value
       *
       * @param type {String}
       * @param name {String}
       * @returns {boolean}
       */
      getUserPreferences: function(type, name) {

        var r = false;

        if (type && name) {
          if (this.settings.hasOwnProperty(type)) {
            if (this.settings[type].hasOwnProperty(name) && this.settings[type[name] && this.settings[type][name].preferences instanceof Array]) {
              r = this.settings[type][name].preferences;
            }
          }
        }

        return r;
      },

      /**
       * Get a predefined type value
       *
       * @param type {String}
       * @param name {String}
       * @param key {String}
       * @returns {boolean}
       */
      getPreferencesByKey: function(type, name, key) {

        var r = false, i, ii;

        if (type && name) {
          if (this.settings.hasOwnProperty(type)) {
            if (this.settings[type].hasOwnProperty(name) && this.settings[type][name].preferences instanceof Array) {
              for (i = 0, ii = this.settings[type][name].preferences.length; i < ii; i++) {
                if (this.settings[type][name].preferences[i].name === key) {
                  r = this.settings[type][name].preferences[i].config;
                  if (this.isEmpty(r)) {
                    r = false;
                  }
                  break;
                }
              }
            }
          }
        }

        return r;
      },

      /**
       * Get a predefined type value
       *
       * @param type {String}
       * @param name {String}
       * @param key {String}
       * @returns {boolean}
       */
      isPreferencesLoadedForKey: function(type, name, key) {

        var r = false, i, ii;

        if (type && name) {
          if (this.settings.hasOwnProperty(type)) {
            if (this.settings[type].hasOwnProperty(name) && this.settings[type][name].preferences instanceof Array) {
              r = true;
            }
          }
        }

        return r;
      },

      isEmpty: function(prop) {
        return (!prop ||
                (typeof prop === 'object' &&
                  Object.keys(prop).length === 0 &&
                  JSON.stringify(prop) === JSON.stringify({}))
                );
      },

      /**
       * Set a predefined type value
       *
       * Accepts:
       * {
       *   type: {String} // app|services|directives|factories|views
       *   name: {String}
       *   value: {*}
       * }
       *
       * @param props {Object}
       * @returns {boolean}
       */
      set: function(props) {
        var r = false, config;

        if (props && props.type && props.name && props.value) {
          config = props.value;
          if (this.settings.hasOwnProperty(props.type)) {
            if (this.settings[props.type]) {
              this.settings[props.type][props.name] = config;
              r = true;
            }
          }
        }

        return r;
      },

      /**
       * Set preferences of a predefined type value
       *
       * Accepts:
       * {
       *   type: {String} // app|services|directives|factories|views
       *   name: {String}
       *   value: {*}
       * }
       *
       * @param props {Object}
       * @returns {boolean}
       */
      setPreferences: function(props) {
        var r = false, i, ii, preferences = [];

        if (props && props.type && props.name && props.value) {
          preferences = props.value || [];
          if (this.settings.hasOwnProperty(props.type)) {
            if (this.settings[props.type]) {
              this.settings[props.type][props.name] = {
                preferences: preferences
              };
              //create a configId map for this view
              for (i = 0, ii = preferences.length; i < ii; i++) {
                this.setConfigId(props.type, props.name, preferences[i]);
              }
              r = true;
            }
          }
        }

        return r;
      },

      /**
       * Set a predefined type value
       *
       * Accepts:
       * {
       *   type: {String} // app|services|directives|factories|views
       *   name: {String}
       *   value: {*}
       * }
       *
       * @param props {Object}
       * @returns {boolean}
       */
      setPreferencesByKey: function(props) {
        var r = false, updatedConfig, i, ii, found = false;

        if (props && props.type && props.name && props.key && props.value) {
          updatedConfig = {
            id: this.getConfigId(props.type, props.name, props.configType, props.key),
            name: props.key,
            config: props.value || {}
          };
          if (this.settings.hasOwnProperty(props.type)) {
            if (this.settings[props.type]) {
              if (!this.settings[props.type].hasOwnProperty(props.name)) {
                //create new setting
                this.set({
                  type: props.type,
                  name: props.name,
                  value: {}
                });
              }
              if (!this.settings[props.type][props.name].preferences || !this.settings[props.type][props.name].preferences instanceof Array) {
                this.settings[props.type][props.name].preferences = [];
              } else {
                //preferences already exists
                //find the key first
                for (i = 0, ii = this.settings[props.type][props.name].preferences.length; i < ii; i++) {
                  if (this.settings[props.type][props.name].preferences[i].name === props.key) {
                    this.settings[props.type][props.name].preferences[i].config = updatedConfig.config;
                    found = true;
                    break;
                  }
                }
              }
              if (!found) {
                //new updatedConfig
                updatedConfig = angular.extend({}, updatedConfig);
                this.settings[props.type][props.name].preferences.push(updatedConfig);
              }
              r = true;

            }
          }
        }

        return r;
      },

      dotsToDashes: function(name) {
        return name.replace(/\./g, '-');
      },

      /**
       * Clears a setting value from a type
       * Optionally remove the value entirely
       *
       * @param type
       * @param name
       * @param (optional) remove
       * @returns {boolean}
       */
      clear: function(type, name, remove) {

        var r = false;

        if (type && name) {
          if (this.settings.hasOwnProperty(type)) {
            if (this.settings[type].hasOwnProperty(name)) {
              this.settings[type][name] = null;
              if (remove) {
                delete this.settings[type][name];
              }
              r = true;
            }
          }
        }

        return r;

      },

      /**
       * Clears a setting value from a type
       * Optionally remove the value entirely
       *
       * @param type
       * @param name
       * @param (optional) remove
       * @returns {boolean}
       */
      clearPreferencesByKey: function(type, name, key, remove) {

        var r = false;

        if (type && name) {
          if (this.settings.hasOwnProperty(type)) {
            if (this.settings[type].hasOwnProperty(name) && this.settings[type][name].preferences instanceof Array) {
              for (i = 0, ii = this.settings[type][name].preferences.length; i < ii; i++) {
                if (this.settings[type][name].preferences[i].name === key) {
                  if (remove) {
                    this.settings[type][name].preferences.splice(i, 1);
                  }else {
                    r = this.settings[type][name].preferences[i].config = {};
                  }
                  break;
                }
              }
            }
          }
        }

        return r;

      },

      save: function(props) {
        var self = this,
          type = props.type,
          name = props.name;
        if(name) {
          if (this.settings.hasOwnProperty(type)) {
            if (this.settings[type].hasOwnProperty(name)) {
              ApiService.userPreferences.update(this.dotsToDashes(name), this.settings[type][name]).then(function(response) {
                $rootScope.$broadcast('ConfigService::SettingsSaved', {name: name});
              }, function(response) {
                $rootScope.$broadcast('ConfigService::SettingsSaved', {name: name});
              });
            }
          }
        }
      }

    };

}]);
